import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './actions';
import PropTypes from 'prop-types';
import { Row, FormGroup, Image } from 'react-bootstrap';
import InputText from '../../../../components/gdc-components-atoms-input-text';
import Label from '../../../../components/gdc-components-atoms-label';

import './styles.css';

export class ProofOfOwnershipMobile extends Component {
    proofOfOwnerToggle = () => {
        this.props.actions.changeProofOfOwnerToggle(true);
    }

    handleOnSelectedCustomerNumber = () => {
        this.props.customerNumberSelectedHandler();
        this.props.actions.changeProofOfOwnerToggle(false);
    }

    handleOnSelectedCreditCard = () => {
        this.props.creditCardSelectedHandler();
        this.props.actions.changeProofOfOwnerToggle(false);
    }

    render() {
        let labelToggle = "Identifix Customer Number";

        if (!this.props.customerNumberSelected) {
            labelToggle = "Last 4 - Credit Card Number";
        }

        return (
            <FormGroup controlId={this.props.id}>
                <Row bsClass={this.props.isToggled === false ? "label-toggle-visible" : "hiden"}>
                    <Label id="label-for-id-mobile" className="label-radio-title label-radio">{labelToggle}</Label>
                    <Image id="icon-chevron-down" className="icon-chevron-down" src="/images/icon-chevron-down.png" alt="Chevron Down" onClick={this.proofOfOwnerToggle} />
                </Row>
                <Row bsClass={this.props.isToggled === false ? "panel-toggle hiden" : "panel-toggle panel-toggle-visible"}>
                    <Row bsClass="">
                        <InputText className="radio"
                            type="radio"
                            id="customer-validation-type-customer-number-mobile"
                            checked={this.props.customerNumberSelected}
                            onChange={this.props.customerNumberSelectedHandler}
                        />
                        <Label id="label-customer-number-mobile"
                            className="label-radio"
                            onClick={this.handleOnSelectedCustomerNumber}>Identifix Customer Number</Label>
                    </Row>
                    <hr className="id-type-divider" />
                    <Row bsClass="">
                        <InputText className="radio"
                            type="radio"
                            id="customer-validation-type-credit-card-mobile"
                            checked={this.props.creditCardSelected}
                            onChange={this.props.creditCardSelectedHandler}
                        />
                        <Label id="label-credit-card-mobile"
                            className="label-radio"
                            onClick={this.handleOnSelectedCreditCard}>Last 4 - Credit Card Number</Label>
                    </Row>
                </Row>
                <Row bsClass="">
                    <InputText type="text"
                        tabIndex={this.props.tabIndex}
                        className={this.props.isError === false ? "form-control striped-input" : "form-control striped-input input-error"}
                        id="proof-of-owner-ship-input-mobile"
                        value={this.props.proofOfOwnerShipValue}
                        placeholder={this.props.proofOfOwnershipPlaceholder}
                        onChange={this.props.proofOfOwnerShipValueChangedHandler}
                        onKeyPress={this.props.onKeyPress} />
                </Row>
            </FormGroup>
        )
    };
}

ProofOfOwnershipMobile.propTypes = {
    isToggled: PropTypes.bool
};

export default connect(
    store => store.proofOfOwnershipMobile,
    dispatch => ({ actions: bindActionCreators(actions, dispatch) })
)(ProofOfOwnershipMobile);


// WEBPACK FOOTER //
// ./src/modules/account-connector/components/proof-of-ownership-mobile/index.js